var lightBox = {
  options: {
  },

  selectors: {
    accomodation_gallery: '.accomodation-gallery ul li a',
    button_open: '.js-accomodation-gallery-button-open',
  },

  init: function () {
    const self = this;

    //Checks
    if (jQuery(self.selectors.accomodation_gallery).length === 0) {
      return;
    }

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    let gallery = jQuery(self.selectors.accomodation_gallery).simpleLightbox();

    jQuery(self.selectors.button_open).on("click", function (event) {
      event.preventDefault();
      gallery.open();
    });
  },
}

export { lightBox };